import { useState, useEffect } from 'react';
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';
import { DropDownSelector, ButtonBasic } from "@lk-gtcom/ecomlab-components";
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { useResponseHandler } from '../../../common/auth';
import { usePushNotifications } from '../../../common/pushNotification';
import './ModalLabelPrinting.scss';

const transformSelectedValues = (selectedValues, settings) => {
    return {
        settings: settings
            ?.map(item => {
                const values = selectedValues[item?.mp_id] || {};
                const result = { mp_id: item?.mp_id };

                // Добавляем только те поля, которые имеют значение
                if (values.format) {
                    result.format = values.format?.value || values.format;
                }
                if (values.type) {
                    result.type = values.type?.value || values.type;
                }

                // Проверяем: есть ли хоть одно заполненное поле КРОМЕ mp_id
                const hasValues = Object.keys(result).some(key => key !== 'mp_id' && result[key]);

                // Возвращаем только если есть заполненные поля
                return hasValues ? result : null;
            })
            ?.filter(Boolean) || []
    };
};

// Инициализация значений из полученных настроек
const initializeSelectedValues = (settingsData, setSelectedValues) => {
    const initialValues = {};
    settingsData?.forEach(item => {
        initialValues[item.mp_id] = {
            format: item.format || null,
            type: item.type || null
        };
    });
    setSelectedValues(initialValues);
};

const ModalLabelPrinting = ({
    checkedItems,
    setIsModal
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    const [postingResults, setPostingResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null)

    const [settings, setSettings] = useState([])
    const [selectedValues, setSelectedValues] = useState({});

    const postings = checkedItems?.map((item) => ({
        api_id: item?.api_id,
        mp_id: item?.mp_id,
        posting_number: item?.['Номер отправления'],
    }));

    // Получаем заказы и их статусы для выбора
    const fetchGetPostingList = () => {
        setLoading(true);
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/package-label';

        fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ postings }),
        })
            .then(handleTableResponse)
            .then((json) => {
                const results = json;
                setPostingResults(results);
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };

    // Получаем настройки для печати
    const fetchGetSettings = () => {
        setLoading(true);
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/package-label/settings';

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => {
                initializeSelectedValues(json, setSelectedValues)
                setSettings(json)
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };

    // Сохранить настройки для печати
    const fetchSetSettings = () => {
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/package-label/settings';

        const body = JSON.stringify(
            transformSelectedValues(selectedValues, settings)
        )

        fetch(url, { method: 'PUT', headers, body })
            .then(response => {
                if (response.status === 400) {
                    return response.json().then(data => {
                        addErrorPush(data?.detail)
                        throw { status: 400, data };
                    });
                }
                return handleTableResponse(response);
            })
            .then((json) => {
                addSuccessPush('настройки сохранены')
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };


    useEffect(() => {
        fetchGetSettings()
        // fetchGetPostingList();
    }, []);

    const handleSelectChange = (mp_id, field, value) => {
        setSelectedValues(prev => ({
            ...prev,
            [mp_id]: {
                ...prev[mp_id],
                [field]: value
            }
        }));
    };

    return (
        <ModalComponent
            title='Настройки типа и формата печати'
            onClose={(e) => setIsModal(false)}
            loading={loading}
            styleContent={{
                overflow: 'visible'
            }}
            style={{
                maxWidth: '600px',
                height: 'auto',
                minHeight: '365px',
                overflow: 'visible'
            }}
            isNoData={!settings.length}
            descriptionNoData='Не удалось получить информацию по отправлениям.'
            child={
                <div className='modal-label-printing'>
                    {
                        !loading &&
                        settings?.map((item, ind) => {
                            const currentValues = selectedValues[item?.mp_id] || {};

                            return <div
                                key={item?.mp_id + ind}
                                className='modal-label-printing__filters'>

                                <img
                                    src={item?.icon}
                                    className='modal-label-printing__icon'
                                    alt='mp' />

                                <DropDownSelector
                                    options_prop={item?.formats || []}
                                    state={currentValues.format || null}
                                    setState={(value) => handleSelectChange(item?.mp_id, 'format', value)}
                                    placeholder="Выберите формат"
                                    isClearable={false}
                                    required
                                />

                                {item?.mp_id == 3 && <DropDownSelector
                                    options_prop={item?.types || []}
                                    state={currentValues.type || null}
                                    setState={(value) => handleSelectChange(item?.mp_id, 'type', value)}
                                    placeholder="Выберите тип"
                                    isClearable={false}
                                    required
                                />}
                            </div>
                        })
                    }

                    <div className='modal-label-printing__btn-box'>
                        <ButtonBasic
                            green
                            text='Сохранить'
                            onClick={fetchSetSettings}
                        />
                    </div>
                </div>
            }
        />
    );
};

export { ModalLabelPrinting };
